import type { ReactNode } from 'react';

export const warehouseFallbackMenuItems = [
  { labelKey: 'menu:warehouse_inventory', path: '/warehouse/inventory' },
  { labelKey: 'menu:warehouse_catalog', path: '/warehouse/inventory/catalog' },
  { labelKey: 'menu:warehouse_documents', path: '/warehouse/inventory/documents' },
  { labelKey: 'menu:warehouse_reports', path: '/warehouse/reports' },
  { labelKey: 'menu:warehouse_suppliers', path: '/warehouse/suppliers' },
] as const;

export function buildWarehouseFallbackMenuItems<T>(
  t: (key: string) => string,
  buildItem: (label: ReactNode, path: string) => T,
): T[] {
  return warehouseFallbackMenuItems.map((item) => buildItem(t(item.labelKey), item.path));
}
